module.exports = __webpack_public_path__ + "static/media/DSC09155_20180710_029-6.cb8a8cf8.jpg";